import { render } from "./ProfileIcon.vue?vue&type=template&id=08846625&scoped=true"
import script from "./ProfileIcon.vue?vue&type=script&lang=js"
export * from "./ProfileIcon.vue?vue&type=script&lang=js"

import "./ProfileIcon.vue?vue&type=style&index=0&id=08846625&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08846625"]])

export default __exports__